import React, { useEffect, useState } from 'react'
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

const LINE_COLORS = ['#44e5e7', '#9FF365', '#33C0A4', '#A8DCD9', '#ECA089']
const LEFT_YTICK_COLOR = '#FFE5FF'

export function formatNumberScale(number) {
  if (isNaN(number) || number === '' || number === undefined) {
    return '0'
  }
  return "$" +parseFloat(number).toFixed(4)
}



const MultiLineChart = ({
  data,
  xDataKey,
  yDataKeys,
  legend,
  format,
}) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (!data.length) {
      return
    }

    setChartData(data)
  }, [data])

  return (
    <ResponsiveContainer width="95%" height={400}>
      <LineChart data={chartData} debounce={1}>
        <CartesianGrid
          horizontal={true}
          vertical={true}
          opacity={0.2}
          strokeDasharray="8"
        />
        <XAxis dataKey={xDataKey} />
        <YAxis
          fontSize="14px"
          yAxisId="left"
          tick={{ stroke: LEFT_YTICK_COLOR }}
          tickLine={{ stroke: LEFT_YTICK_COLOR }}
          domain={['auto', 'auto']}
        />
        {/* <YAxis
          yAxisId="right"
          orientation="right"
          tick={{ stroke: RIGHT_YTICK_COLOR }}
          tickLine={{ stroke: RIGHT_YTICK_COLOR }}
        /> */}
        <Legend />
        {yDataKeys.map((key, index) => (
          <Line
            key={key}
            type="monotone"
            dataKey={key}
            stroke={LINE_COLORS[index]}
            yAxisId={'left'}
            strokeWidth={2}
            dot={false}
            name={legend[index]}
          />
        ))}
        <Tooltip
          contentStyle={{
            backgroundColor: '#05113b',
            border: 'none',
            borderRadius: '12px',
            fontSize: '12px',
          }}
          formatter={format === false ? (data) => data : formatNumberScale}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default MultiLineChart
